import type { ProfileState } from '@/types';
import { ONE_CONTEXT_PROFILE_CONNECTION, ONE_CONTEXT_TENANT, STATUS } from '@/utilities/constants';
import { PL_LOG_GROUPS, logger } from '@/utilities/logger';
import { LOG_LEVEL, PROFILE_CONTEXT_KEYS, useTranslations } from '@b2x/shared';
import { subscribe } from '@seamless/one-context';

export function handleNotifications() {
  subscribe(ONE_CONTEXT_PROFILE_CONNECTION, {
    tenant: ONE_CONTEXT_TENANT,
    componentName: 'PL',
    callback: async (profileState: ProfileState) => {
      const { meta } = profileState;

      if (meta.status === STATUS.FAILURE) {
        // @ts-ignore
        const { renderNotification } = await import(/* @vite-ignore */ '@oneweb/notification');

        const { t } = useTranslations();

        renderNotification({
          message: t(PROFILE_CONTEXT_KEYS.NOTIFICATIONS_PROFILES_NOT_AVAILABLE),
          variant: 'error',
        });

        logger('Sending notification to the user as the profile is not available', {
          args: [meta.status, meta.message],
          group: PL_LOG_GROUPS.NOTIFICATIONS,
          level: LOG_LEVEL.INFO,
        });
      }
    },
  });
}
